const S36_PlumuleHeat={
    "x_labels": [
        "JNP9DAP1",
        "JNP9DAP2",
        "JNP9DAP3",
        "JNP12DAP1",
        "JNP12DAP2",
        "JNP12DAP3",
        "JNP15DAP1",
        "JNP15DAP2",
        "JNP15DAP3",
        "JNP18DAP1",
        "JNP18DAP2",
        "JNP18DAP3",
        "JNP24DAP1",
        "JNP24DAP2",
        "JNP24DAP3"
    ],
    "y_labels": [
        "JNP9DAP1",
        "JNP9DAP2",
        "JNP9DAP3",
        "JNP12DAP1",
        "JNP12DAP2",
        "JNP12DAP3",
        "JNP15DAP1",
        "JNP15DAP2",
        "JNP15DAP3",
        "JNP18DAP1",
        "JNP18DAP2",
        "JNP18DAP3",
        "JNP24DAP1",
        "JNP24DAP2",
        "JNP24DAP3"
    ],
    "data": [
        [
            0,
            0,
            1.0
        ],
        [
            1,
            0,
            0.965
        ],
        [
            2,
            0,
            0.967
        ],
        [
            3,
            0,
            0.9
        ],
        [
            4,
            0,
            0.924
        ],
        [
            5,
            0,
            0.897
        ],
        [
            6,
            0,
            0.689
        ],
        [
            7,
            0,
            0.746
        ],
        [
            8,
            0,
            0.69
        ],
        [
            9,
            0,
            0.606
        ],
        [
            10,
            0,
            0.575
        ],
        [
            11,
            0,
            0.616
        ],
        [
            12,
            0,
            0.309
        ],
        [
            13,
            0,
            0.297
        ],
        [
            14,
            0,
            0.317
        ],
        [
            0,
            1,
            0.965
        ],
        [
            1,
            1,
            1.0
        ],
        [
            2,
            1,
            0.967
        ],
        [
            3,
            1,
            0.884
        ],
        [
            4,
            1,
            0.912
        ],
        [
            5,
            1,
            0.883
        ],
        [
            6,
            1,
            0.682
        ],
        [
            7,
            1,
            0.74
        ],
        [
            8,
            1,
            0.68
        ],
        [
            9,
            1,
            0.602
        ],
        [
            10,
            1,
            0.572
        ],
        [
            11,
            1,
            0.612
        ],
        [
            12,
            1,
            0.318
        ],
        [
            13,
            1,
            0.307
        ],
        [
            14,
            1,
            0.326
        ],
        [
            0,
            2,
            0.967
        ],
        [
            1,
            2,
            0.967
        ],
        [
            2,
            2,
            1.0
        ],
        [
            3,
            2,
            0.886
        ],
        [
            4,
            2,
            0.911
        ],
        [
            5,
            2,
            0.882
        ],
        [
            6,
            2,
            0.677
        ],
        [
            7,
            2,
            0.734
        ],
        [
            8,
            2,
            0.679
        ],
        [
            9,
            2,
            0.597
        ],
        [
            10,
            2,
            0.566
        ],
        [
            11,
            2,
            0.607
        ],
        [
            12,
            2,
            0.312
        ],
        [
            13,
            2,
            0.301
        ],
        [
            14,
            2,
            0.32
        ],
        [
            0,
            3,
            0.9
        ],
        [
            1,
            3,
            0.884
        ],
        [
            2,
            3,
            0.886
        ],
        [
            3,
            3,
            1.0
        ],
        [
            4,
            3,
            0.962
        ],
        [
            5,
            3,
            0.972
        ],
        [
            6,
            3,
            0.841
        ],
        [
            7,
            3,
            0.894
        ],
        [
            8,
            3,
            0.844
        ],
        [
            9,
            3,
            0.759
        ],
        [
            10,
            3,
            0.724
        ],
        [
            11,
            3,
            0.771
        ],
        [
            12,
            3,
            0.367
        ],
        [
            13,
            3,
            0.353
        ],
        [
            14,
            3,
            0.372
        ],
        [
            0,
            4,
            0.924
        ],
        [
            1,
            4,
            0.912
        ],
        [
            2,
            4,
            0.911
        ],
        [
            3,
            4,
            0.962
        ],
        [
            4,
            4,
            1.0
        ],
        [
            5,
            4,
            0.96
        ],
        [
            6,
            4,
            0.815
        ],
        [
            7,
            4,
            0.87
        ],
        [
            8,
            4,
            0.815
        ],
        [
            9,
            4,
            0.721
        ],
        [
            10,
            4,
            0.686
        ],
        [
            11,
            4,
            0.732
        ],
        [
            12,
            4,
            0.357
        ],
        [
            13,
            4,
            0.345
        ],
        [
            14,
            4,
            0.364
        ],
        [
            0,
            5,
            0.897
        ],
        [
            1,
            5,
            0.883
        ],
        [
            2,
            5,
            0.882
        ],
        [
            3,
            5,
            0.972
        ],
        [
            4,
            5,
            0.96
        ],
        [
            5,
            5,
            1.0
        ],
        [
            6,
            5,
            0.841
        ],
        [
            7,
            5,
            0.892
        ],
        [
            8,
            5,
            0.841
        ],
        [
            9,
            5,
            0.762
        ],
        [
            10,
            5,
            0.728
        ],
        [
            11,
            5,
            0.773
        ],
        [
            12,
            5,
            0.371
        ],
        [
            13,
            5,
            0.357
        ],
        [
            14,
            5,
            0.375
        ],
        [
            0,
            6,
            0.689
        ],
        [
            1,
            6,
            0.682
        ],
        [
            2,
            6,
            0.677
        ],
        [
            3,
            6,
            0.841
        ],
        [
            4,
            6,
            0.815
        ],
        [
            5,
            6,
            0.841
        ],
        [
            6,
            6,
            1.0
        ],
        [
            7,
            6,
            0.96
        ],
        [
            8,
            6,
            0.97
        ],
        [
            9,
            6,
            0.934
        ],
        [
            10,
            6,
            0.912
        ],
        [
            11,
            6,
            0.937
        ],
        [
            12,
            6,
            0.519
        ],
        [
            13,
            6,
            0.504
        ],
        [
            14,
            6,
            0.515
        ],
        [
            0,
            7,
            0.746
        ],
        [
            1,
            7,
            0.74
        ],
        [
            2,
            7,
            0.734
        ],
        [
            3,
            7,
            0.894
        ],
        [
            4,
            7,
            0.87
        ],
        [
            5,
            7,
            0.892
        ],
        [
            6,
            7,
            0.96
        ],
        [
            7,
            7,
            1.0
        ],
        [
            8,
            7,
            0.96
        ],
        [
            9,
            7,
            0.9
        ],
        [
            10,
            7,
            0.87
        ],
        [
            11,
            7,
            0.908
        ],
        [
            12,
            7,
            0.469
        ],
        [
            13,
            7,
            0.453
        ],
        [
            14,
            7,
            0.468
        ],
        [
            0,
            8,
            0.69
        ],
        [
            1,
            8,
            0.68
        ],
        [
            2,
            8,
            0.679
        ],
        [
            3,
            8,
            0.844
        ],
        [
            4,
            8,
            0.815
        ],
        [
            5,
            8,
            0.841
        ],
        [
            6,
            8,
            0.97
        ],
        [
            7,
            8,
            0.96
        ],
        [
            8,
            8,
            1.0
        ],
        [
            9,
            8,
            0.934
        ],
        [
            10,
            8,
            0.909
        ],
        [
            11,
            8,
            0.939
        ],
        [
            12,
            8,
            0.517
        ],
        [
            13,
            8,
            0.499
        ],
        [
            14,
            8,
            0.511
        ],
        [
            0,
            9,
            0.606
        ],
        [
            1,
            9,
            0.602
        ],
        [
            2,
            9,
            0.597
        ],
        [
            3,
            9,
            0.759
        ],
        [
            4,
            9,
            0.721
        ],
        [
            5,
            9,
            0.762
        ],
        [
            6,
            9,
            0.934
        ],
        [
            7,
            9,
            0.9
        ],
        [
            8,
            9,
            0.934
        ],
        [
            9,
            9,
            1.0
        ],
        [
            10,
            9,
            0.965
        ],
        [
            11,
            9,
            0.971
        ],
        [
            12,
            9,
            0.6
        ],
        [
            13,
            9,
            0.584
        ],
        [
            14,
            9,
            0.59
        ],
        [
            0,
            10,
            0.575
        ],
        [
            1,
            10,
            0.572
        ],
        [
            2,
            10,
            0.566
        ],
        [
            3,
            10,
            0.724
        ],
        [
            4,
            10,
            0.686
        ],
        [
            5,
            10,
            0.728
        ],
        [
            6,
            10,
            0.912
        ],
        [
            7,
            10,
            0.87
        ],
        [
            8,
            10,
            0.909
        ],
        [
            9,
            10,
            0.965
        ],
        [
            10,
            10,
            1.0
        ],
        [
            11,
            10,
            0.96
        ],
        [
            12,
            10,
            0.634
        ],
        [
            13,
            10,
            0.617
        ],
        [
            14,
            10,
            0.62
        ],
        [
            0,
            11,
            0.616
        ],
        [
            1,
            11,
            0.612
        ],
        [
            2,
            11,
            0.607
        ],
        [
            3,
            11,
            0.771
        ],
        [
            4,
            11,
            0.732
        ],
        [
            5,
            11,
            0.773
        ],
        [
            6,
            11,
            0.937
        ],
        [
            7,
            11,
            0.908
        ],
        [
            8,
            11,
            0.939
        ],
        [
            9,
            11,
            0.971
        ],
        [
            10,
            11,
            0.96
        ],
        [
            11,
            11,
            1.0
        ],
        [
            12,
            11,
            0.583
        ],
        [
            13,
            11,
            0.565
        ],
        [
            14,
            11,
            0.574
        ],
        [
            0,
            12,
            0.309
        ],
        [
            1,
            12,
            0.318
        ],
        [
            2,
            12,
            0.312
        ],
        [
            3,
            12,
            0.367
        ],
        [
            4,
            12,
            0.357
        ],
        [
            5,
            12,
            0.371
        ],
        [
            6,
            12,
            0.519
        ],
        [
            7,
            12,
            0.469
        ],
        [
            8,
            12,
            0.517
        ],
        [
            9,
            12,
            0.6
        ],
        [
            10,
            12,
            0.634
        ],
        [
            11,
            12,
            0.583
        ],
        [
            12,
            12,
            1.0
        ],
        [
            13,
            12,
            0.971
        ],
        [
            14,
            12,
            0.966
        ],
        [
            0,
            13,
            0.297
        ],
        [
            1,
            13,
            0.307
        ],
        [
            2,
            13,
            0.301
        ],
        [
            3,
            13,
            0.353
        ],
        [
            4,
            13,
            0.345
        ],
        [
            5,
            13,
            0.357
        ],
        [
            6,
            13,
            0.504
        ],
        [
            7,
            13,
            0.453
        ],
        [
            8,
            13,
            0.499
        ],
        [
            9,
            13,
            0.584
        ],
        [
            10,
            13,
            0.617
        ],
        [
            11,
            13,
            0.565
        ],
        [
            12,
            13,
            0.971
        ],
        [
            13,
            13,
            1.0
        ],
        [
            14,
            13,
            0.967
        ],
        [
            0,
            14,
            0.317
        ],
        [
            1,
            14,
            0.326
        ],
        [
            2,
            14,
            0.32
        ],
        [
            3,
            14,
            0.372
        ],
        [
            4,
            14,
            0.364
        ],
        [
            5,
            14,
            0.375
        ],
        [
            6,
            14,
            0.515
        ],
        [
            7,
            14,
            0.468
        ],
        [
            8,
            14,
            0.511
        ],
        [
            9,
            14,
            0.59
        ],
        [
            10,
            14,
            0.62
        ],
        [
            11,
            14,
            0.574
        ],
        [
            12,
            14,
            0.966
        ],
        [
            13,
            14,
            0.967
        ],
        [
            14,
            14,
            1.0
        ]
    ]
}
export default S36_PlumuleHeat